import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { UsersService } from '../services/users/users.service';
import { TokenService } from '../services/auth/token.service';

export const RegistrationTokenGuard: CanActivateFn = (route): any => {
  const authService = inject(UsersService);
  const tokenService = inject(TokenService);
  const router = inject(Router);
  const token = route.params['token'];

  if (!token) {
    console.log("CERRAR ENSEGUIDA");
    return of(
      router.createUrlTree(['/auth/login'], {
        queryParams: { message: 'Token no proporcionado' },
      })
    );
  }

  return authService.confirmValidToken(token).pipe(
    map((isValid) => {
      if (isValid && isValid.email) {
        tokenService.setTokenRegister(token);
        localStorage.setItem('email', isValid.email);
        return true;
      } else {
        return router.createUrlTree(['/auth/login'], {
          queryParams: { message: 'Token inválido o expirado' },
        });
      }
    }),
    catchError((err) => {
      console.error('Error validando token:', err);
      return of(
        router.createUrlTree(['/auth/login'], {
          queryParams: { message: 'Token inválido o expirado' },
        })
      );
    })
  );
};